/* ============================================================
   header.js — section "header". Hamburger <-> mobile nav drawer (Figma 6001:32638).
   Owns: open/close, aria-expanded, Esc, focus trap, body scroll lock,
   click-outside (the gradient backdrop), auto-close at >=1024px, and the
   drawer ticker's marquee (re)initialisation once the drawer becomes visible.
   The burger <-> close glyph is an ASSET SWAP driven by [aria-expanded] in CSS
   (D-5) — this file only flips the attribute.
   ============================================================ */
(function () {
  'use strict';

  var drawer = document.getElementById('header-drawer');
  var burger = document.querySelector('.header__burger');
  if (!drawer || !burger) return;

  var closeBtn = drawer.querySelector('.header__drawer-close');
  var plate = drawer.querySelector('.header__drawer-plate');
  var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var isOpen = false;
  var lastFocused = null;
  var lockedScrollY = 0;
  var marqueeReady = false;

  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
    );
  }

  function lockScroll() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  /* The drawer ticker is 0x0 while hidden, so marquee.js computes duration 0 on
     load. Re-run the template's public entrypoint once, the first time the
     drawer is actually laid out. marquee.js is idempotent per --multiplier. */
  function initDrawerMarquee() {
    if (marqueeReady) return;
    if (typeof window.__marqueeInitTicker !== 'function') return;
    window.__marqueeInitTicker(drawer);
    marqueeReady = true;
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.setAttribute('aria-expanded', 'true');
    lockScroll();
    /* let layout settle so the ticker has a real width before measuring */
    window.requestAnimationFrame(initDrawerMarquee);
    var first = focusables()[0];
    if (first) first.focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    /* focus must never be left inside a [hidden] subtree */
    var hadFocus = drawer.contains(document.activeElement);
    drawer.hidden = true;
    burger.setAttribute('aria-expanded', 'false');
    if (closeBtn) closeBtn.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (!hadFocus) return;
    var target = (lastFocused && lastFocused !== document.body &&
                  lastFocused.isConnected && !drawer.contains(lastFocused))
      ? lastFocused : burger;
    /* preventScroll is REQUIRED, not defensive: unlockScroll() has just restored the
       page to lockedScrollY, and focusing the burger scrolls it (page top) back into
       view. With the default `scroll-behavior: smooth` both scrolls animate and the
       restore happens to survive; under `prefers-reduced-motion: reduce` the behaviour
       is `auto`, both are instant, and the focus scroll wins — closing the drawer threw
       the reader back to y=0 (reproduced 15/15 across all 5 close paths × 3 viewports). */
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  burger.addEventListener('click', function () {
    if (isOpen) { close(); } else { open(); }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () { close(); });
  }

  /* click-outside: the gradient backdrop / the bare drawer surface */
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer || e.target === plate) close();
  });

  /* a link tap closes the drawer (placeholders today — BA-4) */
  Array.prototype.forEach.call(
    drawer.querySelectorAll('.header__drawer-link, .header__drawer-cta'),
    function (link) { link.addEventListener('click', function () { close(); }); }
  );

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* the burger does not exist at >=1024px — never leave the drawer stranded open */
  function onDesktop(e) {
    if (e.matches) close();
  }
  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', onDesktop);
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(onDesktop);
  }
})();
